/**
 * H5 本地存储
 */
async function get(table, key) {
    const newKey = table + '_' + key;
    return window.localStorage.getItem(newKey);
}
async function set(table, key, value) {
    const newKey = table + '_' + key;
    return window.localStorage.setItem(newKey, value);
}
async function remove(table, key) {
    const newKey = table + '_' + key;
    return window.localStorage.removeItem(newKey);
}
async function clear(table) {
    console.log('clear not support', table);
}
export default {
    get,
    set,
    remove,
    clear,
};
